import { render, staticRenderFns } from "./StockOverview.vue?vue&type=template&id=5f7f38e2&scoped=true"
import script from "./StockOverview.vue?vue&type=script&lang=js"
export * from "./StockOverview.vue?vue&type=script&lang=js"
import style0 from "./StockOverview.vue?vue&type=style&index=0&id=5f7f38e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f38e2",
  null
  
)

export default component.exports